import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Slider from "rc-slider";
import { calculateExtraCreditsPrice } from "../../../../../../services/utils/calculatePrice";

export default function AddMoreCredits({
  addCreditsToggle,
  handleAddCredits,
  classToggle,
  onAddCredits,
  creditsToAdd,
  subscriptionType,
  planCredits,
  organizationCreditPlan,
  selectedPlan,
}) {
  const [creditsToChange, setCreditsToChange] = useState(creditsToAdd);
  const intl = useIntl();
  useEffect(() => {
    let dots = document.querySelectorAll(".rc-slider-dot");
    const { extraCredits } = calculateExtraCreditsPrice({
      creditType: addCreditsToggle.type,
      isAnnual: subscriptionType == "yearly",
    });
    dots.forEach((element, i) => {
      if (i > 0) {
        const span = document.createElement("span");
        span.innerHTML = extraCredits[i].amount;
        span.classList.add("inject-amount");
        element.appendChild(span);
      }
    });
    return () => {
      let dots = document.querySelectorAll(".rc-slider-dot .inject-amount");
      dots.forEach((dot) => {
        dot.remove();
      });
    };
  }, [addCreditsToggle.type, subscriptionType]);
  const handleSliderOnChange = (slideIndex) => {
    const creditsObg = { ...creditsToAdd };
    //const creditsObg = { ...creditsToChange };

    const { extraCredits } = calculateExtraCreditsPrice({
      creditType: addCreditsToggle.type,
      isAnnual: subscriptionType == "yearly",
    });
    creditsObg[addCreditsToggle.type] = {
      numberOfCredits: parseInt(extraCredits[slideIndex].amount),
      index: slideIndex,
      price: extraCredits[slideIndex].price,
    };
    onAddCredits(creditsObg);
  };
  const credits = {
    phoneCredits: <FormattedMessage id={"billing.phoneCredits"} />,
    personalEmailCredits: (
      <FormattedMessage id={"billing.directEmailCredits"} />
    ),
    exportCredits: <FormattedMessage id={"billing.exportCredits"} />,
  };

  const CurrentCredit = ({ type }) => {
    let creditOptions = {
      operator: "+",
      currentCredits:
        creditsToAdd[type].numberOfCredits - organizationCreditPlan[type].extra,
      color: "green",
    };
    if (organizationCreditPlan.numberOfMonths !== selectedPlan.numberOfMonths) {
      return (
        !!creditsToAdd[type].numberOfCredits && (
          <small style={{ color: creditOptions.color }}>
            {creditOptions.operator} {creditsToAdd[type].numberOfCredits}
          </small>
        )
      );
    }
    if (
      organizationCreditPlan &&
      organizationCreditPlan[type] &&
      organizationCreditPlan[type].extra == creditsToAdd[type].numberOfCredits
    ) {
      creditOptions = {
        operator: "",
        currentCredits: organizationCreditPlan[type].extra,
      };
    }
    if (
      organizationCreditPlan &&
      organizationCreditPlan[type] &&
      organizationCreditPlan[type].extra > creditsToAdd[type].numberOfCredits
    ) {
      creditOptions = {
        operator: "-",
        currentCredits:
          organizationCreditPlan[type].extra -
          creditsToAdd[type].numberOfCredits,
        color: "tomato",
      };
    }
    return (
      !!creditsToAdd[type].numberOfCredits && (
        <small style={{ color: creditOptions.color }}>
          {creditOptions.operator} {creditOptions.currentCredits}
        </small>
      )
    );
  };
  return (
    <div className={"credits-section " + classToggle}>
      <section>
        <div className="credit-type-tabs">
          <span
            className={
              addCreditsToggle.type === "phoneCredits" ? "selected" : ""
            }
            onClick={() => handleAddCredits("phoneCredits")}
          >
            <FormattedMessage id={"billing.phoneCredits"} />
            <CurrentCredit type={"phoneCredits"} />
          </span>
          <span
            className={
              addCreditsToggle.type === "personalEmailCredits" ? "selected" : ""
            }
            onClick={() => handleAddCredits("personalEmailCredits")}
          >
            <FormattedMessage id={"billing.directEmailCredits"} />
            <CurrentCredit type={"personalEmailCredits"} />
          </span>
          <span
            className={
              addCreditsToggle.type === "exportCredits" ? "selected" : ""
            }
            onClick={() => handleAddCredits("exportCredits")}
          >
            <FormattedMessage id={"billing.exportCredits"} />
            <CurrentCredit type={"exportCredits"} />
          </span>
        </div>
        <div className="custom-credit-type global-fade-in">
          <div className={"info-credit-wrapper"}>
            <div>
              <h5> {credits[addCreditsToggle.type]}</h5>
              <p style={{ marginTop: -3 }}>
                <FormattedMessage id={"billing.additionalCredits"} />
              </p>
            </div>
            {/*  <div>
              <p>
                {intl.formatMessage({ id: "billing.inThePlan" })} (
                {subscriptionType == "yearly"
                  ? planCredits.perSeat * 12 +
                    intl.formatMessage({ id: "billing.creditsYear" })
                  : planCredits.perSeat +
                    intl.formatMessage({ id: "billing.creditsMonth" })}
                )
              </p>
            </div>*/}
          </div>
          <div className={"info-credit-wrapper"}>
            <div>
              <strong>
                {creditsToAdd[addCreditsToggle.type].numberOfCredits}{" "}
              </strong>{" "}
              <FormattedMessage id={"credits"} /> /{" "}
              {subscriptionType == "yearly" ? (
                <FormattedMessage id={"year"} />
              ) : (
                <FormattedMessage id={"month"} />
              )}{" "}
            </div>
            <div>
              <strong> {creditsToAdd[addCreditsToggle.type].price} €</strong> /
              {subscriptionType == "yearly" ? (
                <FormattedMessage id={"year"} />
              ) : (
                <FormattedMessage id={"month"} />
              )}
            </div>
          </div>
          <div className={"add-credits-slider"}>
            <Slider
              min={0}
              max={
                calculateExtraCreditsPrice({
                  creditType: addCreditsToggle.type,
                  isAnnual: subscriptionType == "yearly",
                }).totalItems
              }
              value={creditsToAdd[addCreditsToggle.type].index}
              onChange={handleSliderOnChange}
              dots
            />
            {/*   <div className={"slider_2"}>
              <Slider
                  min={0}
                  max={
                    calculateExtraCreditsPrice({
                      creditType: addCreditsToggle.type,
                    }).totalItems
                  }
                  value={creditsToChange[addCreditsToggle.type].index}
                  onChange={handleSliderOnChange}

              />
            </div>*/}
          </div>
        </div>
      </section>
    </div>
  );
}
